import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DatatableViewComponent} from '@ngx-ivengi/crud';
import {Channel} from '../channel/channel.model';
import {ConfirmationModalComponent} from '../confirmation/confirmation-modal.component';
import {Throughput} from './throughput.model';
import {ThroughputService} from './throughput.service';
import {RoutePrefix} from '../shared/route-prefix';
import {UIRouter} from '@uirouter/angular';

@Component({
  selector: 'app-throughput-datatable',
  templateUrl: './throughput-datatable.component.html'
})
export class ThroughputDatatableComponent extends DatatableViewComponent<Throughput> implements OnInit {

  @Input() public routePrefix: RoutePrefix | RoutePrefix[];
  @Input() public viewMode: boolean = false;
  public throughputEditStateName: string;

  @ViewChild(ConfirmationModalComponent)
  public confirmationModal: ConfirmationModalComponent;

  constructor(
    private router: UIRouter,
    private throughputService: ThroughputService
  ) {
    super(throughputService);
  }

  ngOnInit(): void {
    this.throughputEditStateName = `${this.router.stateService.$current.name}.throughput.edit`;

    if(this.routePrefix) {
      const prefixParts = (this.routePrefix instanceof Array) ? this.routePrefix : [this.routePrefix];

      const prefix  = prefixParts.map((item) => {
        return `${item.entity}/${item.entityId}`;
      });

      this.throughputService.setRoutePrefix(prefix.join('/').toLowerCase());
    }

    this.fetchData();
  }

  public deleteItem(item) {
    this.confirmationModal.show(item);
  }

  public onDeleteConfirmation(event) {
    if(event.confirmed === true) {
      this.throughputService.delete(event.data).subscribe(() => {
        this.router.stateService.go(this.router.stateService.$current.name, this.router.stateService.params, {reload: true});
      });
    }
  }


  public onRowClick(event) {
    if (event.type !== 'dblclick' || typeof event.column === 'undefined' || event.column.prop === 'menu' || typeof event.row === 'undefined') {
      return;
    }
    this.router.stateService.go(this.throughputEditStateName, { throughputId: event.row.id }, { reload: true });
  }}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/throughput/throughput-datatable.component.ts